import { httpV1 as http } from '../api';

export async function getLiveloStatement() {
  const { data } = await http.get('/rewards/summary');
  return data;
}

export async function transferRewards() {
  const { data } = await http.post('/rewards/transfers');
  return data;
}
